import TrophyChallengeIndex from "./TrophyChallengeIndex";
import {ROLE} from "../../../shared/utils/enum";

export const trophyChallengeRoutes = {
    path: "/trophyChallenge",
    component: <TrophyChallengeIndex/>,
    role: ROLE.DEVELOP,
}
